import React from 'react';
import { Link } from 'react-router-dom';

interface AuthBrandingHeaderProps {
  eyebrow: string;
  headline: string;
}

export const AuthBrandingHeader: React.FC<AuthBrandingHeaderProps> = ({ eyebrow, headline }) => {
  return (
    <Link to="/" className="flex items-center gap-3">
      <img
        src="/logos/Smart Prompt Logo.png"
        alt="Smart Prompt logo"
        className="w-12 h-12 object-contain"
        onError={(e) => {
          const target = e.currentTarget;
          target.style.display = 'none';
          const fallback = target.nextElementSibling as HTMLElement;
          if (fallback) {
            fallback.style.display = 'flex';
          }
        }}
      />
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center shadow-lg shadow-cyan-500/20 hidden">
        <span className="text-lg font-bold text-white">SP</span>
      </div>
      <div>
        <p className="text-sm text-slate-300">{eyebrow}</p>
        <p className="text-2xl font-semibold">{headline}</p>
      </div>
    </Link>
  );
};
